import { IonButton, IonCol, IonIcon, IonRow, IonText, useIonToast } from '@ionic/react';
import { downloadOutline } from 'ionicons/icons';
import { AuthContext } from '../../context/AuthContext';
import './DownloadDoc.css'

interface Props {
    id: any;
    title: string,
    small?: boolean
}

const DownloadDoc: React.FC<Props> = (props) => {
    const [toast, dismiss] = useIonToast();
    const showDocGuestMessageHandler = () => {
        toast({ message: "جهت دریافت سند ابتدا باید در سایت ثبت نام کنید.", duration: 2000, color: "warning" })
    }

    return (
        <AuthContext.Consumer>
            {
                (context) => {
                    return <>
                        {context.auth ?
                        <IonButton className={'campaign-doc-download' + (props.small ? " campaign-doc-download-small" : "")} expand='block' color="danger" routerLink={`/campaign/${props.id}/tree-doc`}>
                            <IonIcon slot='start' src={downloadOutline} /> دریافت سند/پلاک
                        </IonButton> :
                        <IonButton className={'campaign-doc-download'  + (props.small ? " campaign-doc-download-small" : "")} expand='block' color="danger" onClick={showDocGuestMessageHandler}>
                            <IonIcon slot='start' src={downloadOutline} /> دریافت سند / پلاک
                        </IonButton>}
                    </>
                }
            }
        </AuthContext.Consumer>
    );
};

export default DownloadDoc;
